import React from "react";
import { CircleMarker, Polygon, Polyline } from "react-leaflet";
import {
  SELECTION_HIGHLIGHT_OPTIONS,
  teeCenterLatLng,
} from "./selectionDelete";

const SelectionHighlightLayer = ({ vectorShapes, teeCenters }) => {
  const shapeHighlights = vectorShapes.map((shape) => {
    if (shape.type === "polygon") {
      return (
        <Polygon
          key={shape._id}
          positions={shape.list}
          pathOptions={SELECTION_HIGHLIGHT_OPTIONS}
          interactive={false}
        />
      );
    }
    if (shape.type === "line") {
      return (
        <Polyline
          key={shape._id}
          positions={shape.list[0]}
          pathOptions={SELECTION_HIGHLIGHT_OPTIONS}
          interactive={false}
        />
      );
    }
    const point = shape.list.flat(3);
    return (
      <CircleMarker
        key={shape._id}
        center={[point[0], point[1]]}
        radius={12}
        pathOptions={SELECTION_HIGHLIGHT_OPTIONS}
        interactive={false}
      />
    );
  });

  const teeHighlights = teeCenters.map((tee) => (
    <CircleMarker
      key={tee.id}
      center={teeCenterLatLng(tee)}
      radius={12}
      pathOptions={SELECTION_HIGHLIGHT_OPTIONS}
      interactive={false}
    />
  ));

  return (
    <>
      {shapeHighlights}
      {teeHighlights}
    </>
  );
};

SelectionHighlightLayer.defaultProps = {
  vectorShapes: [],
  teeCenters: [],
};

export default SelectionHighlightLayer;
